module.exports = __webpack_public_path__ + "static/clients-shaking-hands-mobile.032a80af.webp";